import { render, staticRenderFns } from "./equipList.vue?vue&type=template&id=85072d7a&scoped=true"
import script from "./equipList.vue?vue&type=script&lang=js"
export * from "./equipList.vue?vue&type=script&lang=js"
import style0 from "./equipList.vue?vue&type=style&index=0&id=85072d7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85072d7a",
  null
  
)

export default component.exports